import secureLocalStorage from "react-secure-storage";
import { useSelector } from "react-redux";
import { store } from "../redux/store";

export const getStoredUser = () => {
  try {
    return secureLocalStorage.getItem("user");
  } catch (error) {
    console.error("Failed to parse user from session", error);
    return null;
  }
};

export const getStoredDeviceInfo = () => {
  try {
    return secureLocalStorage.getItem("deviceInfo");
  } catch (error) {
    console.error("Failed to parse user from session", error);
    return [];
  }
}

export const getStoredUserFeatures = () => {
  try {
    return secureLocalStorage.getItem("userFeatures");
  } catch (error) {
    console.error("Failed to parse user from session", error);
    return null;
  }
}
export const getStoredFeatureMenu = () => {
  try {
    return secureLocalStorage.getItem("featureMenu");
  } catch (error) {
    console.error("Failed to parse user from session", error);
    return [];
  }
}

export const getStoredCompany = () => {
  try {
    return secureLocalStorage.getItem("company");
  } catch (error) {
    console.error("Failed to parse company from session", error);
    return null;
  }
};

export const getReduxCompany = () => {
  try {
    const state = store.getState();
    return state.company?.data;
  } catch (error) {
    console.error("Failed to parse company from redux", error);
    return null;
  }
};


export const useGetCodeWiseAppModuleFeaturePermission = (featureCode) => {
  const userFeatures = useSelector((state) => state?.userFeatures?.data);

  // const feature = userFeatures?.flatMap((module) => module.features).find((feature) => feature?.featureCode === featureCode);
  let feature = userFeatures?.find(f => f?.featureCode === featureCode);
  return feature;
};
export const useGetIdWiseAppModuleFeaturePermission = (applicationModuleFeatureId) => {
  const userModules = useSelector((state) => state?.userFeatures?.data?.modules);

  const feature = userModules
    ?.flatMap((module) => module.features)
    .find((feature) => feature.applicationModuleFeatureId === applicationModuleFeatureId);

  return feature;
};

export const useIsAllowedAllPermissionsForSomeRoles = (allowedRoleId) => {
  // No user should have special permission, everything should work as per assigned role permission
  return false;

  const user = useSelector((state) => state.user.data);
  allowedRoleId = allowedRoleId ?? [1, 9]; //Admin, SuperAdmin
  const isAllowedForThisRole = user?.roleList?.some(role =>
    allowedRoleId?.includes(role?.roleId)
  );

  return isAllowedForThisRole;
}
